import React from 'react';
import { useTranslatedText } from '../../hooks/useTranslatedText';

interface TranslatedTextProps {
  text: string | undefined;
  sourceLang?: string;
  fallback?: string;
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3';
  className?: string;
}

/**
 * Renders CMS/admin content with auto-translation to user's language.
 * Only translates when text is from CMS (user-entered). Fallback is shown as-is (already localized).
 */
export const TranslatedText: React.FC<TranslatedTextProps> = ({ text, sourceLang = 'ru', fallback = '', as: Tag = 'span', className }) => {
  const hasCmsContent = (text || '').trim().length > 0;
  const translated = useTranslatedText(hasCmsContent ? (text || '') : '', sourceLang);
  const toShow = hasCmsContent ? (translated || text) : fallback;
  return <Tag className={className}>{toShow}</Tag>;
};
